import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const LikeIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="like-icon"
    boxSize={6}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7026 5.25C10.5364 5.25 10.3829 5.33919 10.3007 5.48362L6.95469 11.3569C6.51115 12.1354 6.32502 13.0342 6.4229 13.9249L6.77604 17.1385C6.83887 17.7103 7.28774 18.1632 7.85894 18.2312L9.97599 18.483C11.3736 18.6493 12.7906 18.5051 14.1261 18.0609C14.7856 17.8416 15.3139 17.341 15.5684 16.6942L17.2725 12.3636C17.3141 12.2578 17.3429 12.1473 17.3582 12.0345C17.4875 11.0824 16.654 10.2792 15.7073 10.4437L12.2915 11.0369C11.2125 11.2243 10.2806 10.2722 10.4912 9.19744L11.1566 5.80158C11.2126 5.51581 10.9938 5.25 10.7026 5.25ZM8.99733 4.74111C9.34641 4.12836 9.9974 3.75001 10.7026 3.75C11.938 3.74999 12.8662 4.87768 12.6286 6.09001L11.9632 9.48587C11.9604 9.50042 11.9619 9.50931 11.9639 9.51569C11.9664 9.52355 11.9714 9.53276 11.9798 9.5413C11.9881 9.54984 11.9972 9.5551 12.005 9.55774C12.0114 9.55988 12.0202 9.5616 12.0348 9.55906L15.4507 8.96579C17.3968 8.62777 19.1103 10.2789 18.8446 12.2363C18.8131 12.4681 18.7539 12.6952 18.6683 12.9129L16.9642 17.2435C16.5469 18.3039 15.6808 19.1246 14.5995 19.4843C13.0546 19.9981 11.4155 20.1648 9.7988 19.9725L7.68175 19.7207C6.41755 19.5703 5.42408 18.5679 5.28501 17.3024L4.93187 14.0887C4.79946 12.8837 5.05128 11.6677 5.65135 10.6143L8.99733 4.74111Z"
      fill="currentColor"
    />
  </Icon>
);
